import type { ComponentProps } from "react";
import { motion } from "motion/react";

import { tw } from "@/shared/utils";

export const AnimatedFields = ({
  className,
  ...props
}: ComponentProps<typeof motion.div>) => {
  return (
    <motion.div
      className={tw("grid gap-x-8 gap-y-1.5", className)}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.2 }}
      {...props}
    />
  );
};
